import { connect } from 'react-redux'
import { notifyActions, playerActions } from '../store/actions';
import pageIpAccess from './pages/ipAccess';

const mapStateToProps = state => {
    return {
        ...state,
        player: state.player,
        role: state.role,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getLoginInfoIp: (data) => {
            dispatch(playerActions.getLoginInfoIp(data))
        },
        setIdPlayerForDetail: (data) => {
            dispatch(playerActions.setIdPlayerForDetail(data))
        },
        successNotify: (message) => {
            dispatch(notifyActions.successAction(message))
        },
        warningNotify: (message) => {
            dispatch(notifyActions.warningAction(message))
        },
        errorNotify: (message) => {
            dispatch(notifyActions.errorAction(message))
        },
        infoNotify: (message) => {
            dispatch(notifyActions.infoAction(message))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageIpAccess);